import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';

@Component({
  selector: 'app-role-card',
  templateUrl: './role-card.component.html',
  styleUrls: ['./role-card.component.css']
})
export class RoleCardComponent implements OnInit {

  constructor() { }
  @Input() roles;
  @Output() clickAction = new EventEmitter();


  ngOnInit() {
  }

  onSlide(evt,id,number,text) {

    let obj = {
      evt : evt,
      roleId: id,
      pageNo: number,
      searchText: text
    }
    this.clickAction.emit(obj);

  }



}
